import React from "react";
import {
  Grid,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Button,
} from "@material-ui/core";
import styled from "styled-components";
import DatetimeCriteriaConfig from "./DatetimeCriteriaConfig";

const todayDate = new Date();
const Options = [
  { name: Ext.Date.format(todayDate, "M j, Y g:iA"), val: "M j, Y g:iA" },
  { name: Ext.Date.format(todayDate, "n/j/Y g:iA"), val: "n/j/Y g:iA" },
  { name: Ext.Date.format(todayDate, "Y/n/j g:iA"), val: "Y/n/j g:iA" },
  { name: Ext.Date.format(todayDate, "D, M j g:iA"), val: "D, M j g:iA" },
];

function DateTimeColumnConfig({
  values,
  handleChange,
  setFieldValue,
  valuesPath = "",
  isOnlyFormattingConfig,
  store,
}) {
  const [criteriaAnchorEl, setCriteriaAnchorEl] = React.useState(null);

  React.useEffect(() => {
    if (values.options.format) {
      return;
    }
    setFieldValue(`${valuesPath}options.format`, "M j, Y g:iA");
  }, [setFieldValue, values.options.format, valuesPath]);

  const hasCriteria = !!values.options.datetime_criteria;

  return (
    <React.Fragment>
      <Grid item xs={12}>
        <Select
          name={`${valuesPath}options.format`}
          value={values.options.format ?? ""}
          onChange={handleChange}
          variant="outlined"
          style={{ width: 200 }}
        >
          {Options.map((option) => (
            <MenuItem key={option.val} value={option.val}>
              {option.name}
            </MenuItem>
          ))}
        </Select>
      </Grid>
      {!isOnlyFormattingConfig && (
        <>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  color="primary"
                  name={`${valuesPath}options.default_current_time`}
                  checked={values.options.default_current_time ?? ""}
                  onChange={handleChange}
                />
              }
              label={"Default as Current Time"}
            />
          </Grid>
          {values.options.default_current_time && (
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    color="primary"
                    name={`${valuesPath}options.allow_free_text`}
                    checked={!values.options.allow_free_text}
                    onChange={() =>
                      setFieldValue(
                        `${valuesPath}options.allow_free_text`,
                        !values.options.allow_free_text
                      )
                    }
                  />
                }
                label={"Do not allow to change Time"}
              />
            </Grid>
          )}

          <Grid item xs={12}>
            <CriteriaButton
              variant="outlined"
              size="small"
              $active={hasCriteria}
              onClick={(e) => setCriteriaAnchorEl(e.currentTarget)}
            >
              Datetime Criteria
              {hasCriteria && <ActiveDot />}
            </CriteriaButton>
          </Grid>
        </>
      )}

      <DatetimeCriteriaConfig
        anchorEl={criteriaAnchorEl}
        onClose={() => setCriteriaAnchorEl(null)}
        values={values}
        setFieldValue={setFieldValue}
        valuesPath={valuesPath}
        columnType="datetime"
        store={store}
      />
    </React.Fragment>
  );
}

const CriteriaButton = styled(Button)`
  text-transform: none !important;
  font-size: 12px !important;
  border-color: ${({ $active }) =>
    $active ? "#1976d2 !important" : "rgba(0,0,0,0.23) !important"};
  color: ${({ $active }) =>
    $active ? "#1976d2 !important" : "rgba(0,0,0,0.6) !important"};
  position: relative !important;
`;

const ActiveDot = styled.span`
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #1976d2;
  margin-left: 6px;
  vertical-align: middle;
`;

export default DateTimeColumnConfig;
